module.exports = __webpack_public_path__ + "static/img/success10.8af2fda5.png";